import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getDataFromServer } from '../utils/apiBase';
import CommonTable from './CommonTable';

function Patient() {
  const navigate = useNavigate();
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = Cookies.get('patient_token');
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate('/patient-verification');
    } else {
      getDataFromServer({
        end_point: 'apiForPatientData',
        params: {
          token: token,
          type: 'application/json',
        },
        call_back: (result) => {
          setLoading(false);
          if (result.status === 'success') {
            setPatientData(result.response);
          } else {
            toast.error(result.error || 'Failed to fetch patient data');
          }
        },
        props: { header: true },
      });
    }
  }, [token, navigate]);

  if (loading) {
    return <div>Loading patient data...</div>;
  }

  const columns = [
    { key: 'user', header: 'User' },
    { key: 'location', header: 'Location' },
    { key: 'name', header: 'Name' },
    { key: 'study', header: 'Study' },
    { key: 'Date', header: 'Date' },
    { key: 'modality', header: 'Modality' },
    { key: 'patientID', header: 'PatientID' },
    { key: 'status', header: 'Status' },
    { key: 'other', header: 'Viewer' },
    { key: 'share', header: 'Share Report' },
  ];

  return (
    <div>
      
      {patientData ? (
        <div>
          <CommonTable
            data={patientData}
            columns={columns}
            isLoading={loading}
            setIsLoading={setLoading}
            setUploadSuccess={setUploadSuccess}
          />
        </div>
      ) : (
        <div>No patient data available.</div>
      )}
    </div>
  );
}

export default Patient;
